import { render, staticRenderFns } from "./Calorie.vue?vue&type=template&id=5c1951b3&"
import script from "./Calorie.vue?vue&type=script&lang=js&"
export * from "./Calorie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports